import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen grid place-items-center px-4">
      <div className="card-surface p-8 max-w-md w-full text-center">
        <div className="text-primary text-5xl font-heading font-bold">404</div>
        <h1 className="font-heading text-2xl font-semibold mt-2">Seite nicht gefunden</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Die angefragte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link to="/">
          <Button className="mt-6 rounded-full">Zur Startseite</Button>
        </Link>
      </div>
    </div>
  );
}
